window.addEventListener('load',function(){

    // description

    const headings = document.querySelectorAll(".description-content");

    // First item active by default
    if (headings.length > 0) {
    headings[0].classList.add("active");
    }

    headings.forEach((heading) => {
    heading.addEventListener("click", () => {
        const isActive = heading.classList.contains("active");

        // Remove active from all
        headings.forEach((h) => h.classList.remove("active"));

        // Toggle current
        if (!isActive) {
        heading.classList.add("active");
        }
    });
    });
})



try{
    
// Initialize Swiper
const thumbSwiper = new Swiper(".thumb-slider", {
  slidesPerView: 3,
  spaceBetween: 15,
  navigation: {
    nextEl: ".thumb-next",
    prevEl: ".thumb-prev",
  },
  centeredSlides: false,
  loop: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    768: { slidesPerView: 2, spaceBetween: 10 },
    1024: { slidesPerView: 3, spaceBetween: 10 },
    1440: { slidesPerView: 4, spaceBetween: 10 },
  },
});
// Get main image
const mainImg = document.querySelector(".main-img");

// Get all slides
const slides = document.querySelectorAll(".swiper-slide");

// Add click event to each slide
slides.forEach((slide) => {
  slide.addEventListener("click", function () {
    slides.forEach((s) => s.classList.remove("active"));
    this.classList.add("active");
    const imgSrc = this.querySelector("img").src;
    mainImg.src = imgSrc;
  });
});

// ADD THIS — autoplay changes active slide
thumbSwiper.on("slideChange", function () {
  const firstVisible = thumbSwiper.slides[thumbSwiper.activeIndex];
  slides.forEach((s) => s.classList.remove("active"));
  firstVisible.classList.add("active");
  mainImg.src = firstVisible.querySelector("img").src;
});

// const thumbsSwiper = new Swiper(".shop-slider-nav", {
//   freeMode: true,
//   watchSlidesProgress: true,
//   watchSlidesVisibility: true,

//   slidesPerView: 4,
//   spaceBetween: 0,
//   grabCursor: true,
// });

// new Swiper(".shop-slider", {
//   slidesPerView: 4,
//   spaceBetween: 10,
//   loop: true,
//   grabCursor: true,
//   autoplay: {
//     delay: 3500,
//     disableOnInteraction: false,
//   },
//   breakpoints: {
//     0: {
//       // very small phones
//       slidesPerView: 2.3,
//       spaceBetween: 0,
//     },
//     490: {
//       // tablets
//       slidesPerView: 2.2,
//       spaceBetween: 0,
//     },
//     767: {
//       // tablets
//       slidesPerView: 2.5,
//       spaceBetween: 0,
//     },
//   },
//   autoplay: {
//     delay: 5000,
//     disableOnInteraction: false,
//   },

//   navigation: {
//     nextEl: ".shop-next",
//     prevEl: ".shop-prev",
//   },
//   // pagination (dots)
//   pagination: {
//     el: ".shop-dots",
//     clickable: true,
//   },
//   speed: 500,
//   thumbs: {
//     swiper: thumbsSwiper, // Link main slider to thumbs
//   },
// });

const shopSwiper = new Swiper(".shop-slider", {
            slidesPerView: 4,
            spaceBetween: 0,
            loop: false,
            grabCursor: true,

            pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
            },

            navigation: {
                nextEl: ".swiper-next",
                prevEl: ".swiper-prev",
            },

            breakpoints: {
                0: {
                    slidesPerView: 2.2,
                },
                430: {
                    slidesPerView: 2.5,
                },
                768: {
                    slidesPerView: 2.5,
                },
                1024: {
                    slidesPerView: 4,
                },
            },
        });

}catch(err){
    console.log(err)
}

document.addEventListener("DOMContentLoaded", () => {
  const questions = document.querySelectorAll(".question");

  if (!questions.length) return;

  // Set first question active by default
  questions[0].classList.add("active");

  questions.forEach((question) => {
    question.addEventListener("click", function () {
      // Remove active class from all
      questions.forEach((q) => q.classList.remove("active"));

      // Add active to clicked one
      this.classList.add("active");
    });
  });
});

